// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMButton.tsx — PropelMapper button.
//
// Pills (radius 999, min-height 46 / 36 sm). Three-role color: `go` = Pine
// (start/advance, default), `end` = Coral (end/close), `danger` = Error red
// (destructive confirms) — plus `outline` / `outline-end` / `ghost` / `text`.
// Optional icon (custom PropelMapper base name, outline glyph, tinted to the
// label color via currentColor; Material Symbols ligature fallback). All colors
// are --pm-* tokens; focus uses --pm-focus-ring.

const PMBTN_CSS = `
.pmbtn{box-sizing:border-box;display:inline-flex;align-items:center;justify-content:center;gap:8px;font-family:var(--pm-font-sans);font-weight:600;font-size:15px;line-height:1;border-radius:var(--pm-radius-pill,999px);min-height:46px;padding:0 20px;border:1.5px solid transparent;cursor:pointer;text-decoration:none;transition:.13s;white-space:nowrap}
.pmbtn:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmbtn:active{transform:scale(.98)}
.pmbtn[aria-disabled="true"],.pmbtn[disabled]{opacity:.45;pointer-events:none}
.pmbtn-ic{display:inline-flex;flex:0 0 auto;line-height:0;width:19px;height:19px}
.pmbtn-ic svg{width:100%;height:100%;display:block}
.pmbtn--go{background:var(--pm-primary);color:#fff;border-color:var(--pm-primary)}
.pmbtn--go:hover{background:var(--pm-primary-dark);border-color:var(--pm-primary-dark)}
.pmbtn--end{background:var(--pm-accent-critical);color:#fff;border-color:var(--pm-accent-critical)}
.pmbtn--end:hover{filter:brightness(.93)}
.pmbtn--danger{background:var(--pm-error);color:#fff;border-color:var(--pm-error)}
.pmbtn--danger:hover{filter:brightness(.93)}
.pmbtn--outline{background:transparent;color:var(--pm-primary);border-color:var(--pm-primary)}
.pmbtn--outline:hover{background:var(--pm-primary-surface)}
.pmbtn--outline-end{background:transparent;color:var(--pm-accent-critical);border-color:var(--pm-accent-critical)}
.pmbtn--outline-end:hover{background:var(--pm-surface-error)}
.pmbtn--ghost{background:var(--pm-surface-variant);color:var(--pm-fg-1);border-color:transparent}
.pmbtn--ghost:hover{background:var(--pm-surface-tertiary)}
.pmbtn--text{background:transparent;color:var(--pm-primary);border-color:transparent;padding:0 10px}
.pmbtn--text:hover{background:var(--pm-primary-surface)}
.pmbtn--sm{min-height:36px;font-size:13px;padding:0 14px;gap:6px}
.pmbtn--sm.pmbtn--text{padding:0 8px}
.pmbtn--sm .pmbtn-ic{width:17px;height:17px}
.pmbtn--block{width:100%}
`;

function pmbtnEnsureCSS() {
  if (typeof document === "undefined") return;
  if (document.getElementById("pmbtn-css")) return;
  const s = document.createElement("style");
  s.id = "pmbtn-css";
  s.textContent = PMBTN_CSS;
  document.head.appendChild(s);
}

const PMBTN_ICON_VARS = {
  "--icon-fg": "currentColor",
  "--icon-accent": "currentColor",
  "--icon-accent-2": "currentColor",
  "--icon-accent-3": "currentColor",
};
function pmbtnIcon(base, size) {
  if (!base) return null;
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const name = I[base + "-outline"] ? base + "-outline" : (I[base] ? base : null);
  if (name && I[name]) {
    return <span className="pmbtn-ic" aria-hidden="true"
      style={{ width: size, height: size, ...PMBTN_ICON_VARS }}
      dangerouslySetInnerHTML={{ __html: I[name] }} />;
  }
  return <span className="material-symbols-outlined pmbtn-ic" aria-hidden="true"
    style={{ fontSize: size, lineHeight: 0, width: "auto", height: "auto" }}>{base}</span>;
}

export function PMButton({
  variant = "go",
  size = "md",
  icon,
  iconRight,
  block = false,
  disabled = false,
  href,
  type = "button",
  className = "",
  style = {},
  children,
  onClick,
  ...rest
}) {
  pmbtnEnsureCSS();
  const isSm = size === "sm";
  const iconSize = isSm ? 17 : 19;
  const cls =
    "pmbtn pmbtn--" + variant +
    (isSm ? " pmbtn--sm" : "") +
    (block ? " pmbtn--block" : "") +
    (className ? " " + className : "");
  const inner = (
    <React.Fragment>
      {icon ? pmbtnIcon(icon, iconSize) : null}
      {children != null ? <span>{children}</span> : null}
      {iconRight ? pmbtnIcon(iconRight, iconSize) : null}
    </React.Fragment>
  );
  if (href && !disabled) {
    return <a className={cls} href={href} style={style} onClick={onClick} {...rest}>{inner}</a>;
  }
  return (
    <button className={cls} type={type} disabled={disabled} style={style} onClick={onClick} {...rest}>
      {inner}
    </button>
  );
}
